import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  logged: false,
  id: "",
  nombre_completo: "",
  email: "",
  user: "",
  moneda: "",
  saldo_juego: "",
  saldo_retiro: "",
  saldo_bonos: "",
  imgPerfil: "",
  telefono: "",
  cedula: "",
  tipo: "",
  factor1: "",
  factor25: "",
  factor05: "",
  bpick2: "",
  bpick3: "",
  bpick4: "",
  bpick5: "",
  bpick6: "",
  bwin: "",
  bplace: "",
  bshow: "",
  bexacta: "",
  btrifecta: "",
  bsuperfecta: "",
  factor_exo: "",
  limite_cantidad: "",
  documento_valido: "",
  verified: "",
  personal_document: "",
  validacion_video: false,
  validacion_video_hipo: "",
  showVideo: null,
  estado_user: "",
  token: "",
  typeSell: "",
  totalPago: false,
  id_totalPago: "",
  activePage: "/",
  detectedCountry: "",
  bonoCompleted: false,
  casino_evo:"",
  casino_ezug:"",
  casino_prag:"",
  casino_tvbet:"",
  slot_pragmatic:"",
  slot_spinmatic:"",
  blockNotVerifiedPeru: false,
  blockDeposit: false,
  blockRetiro: false
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUserLoginDetails: (state, action) => {
      state.id = action.payload.id;
      state.user = action.payload.user;
      state.moneda = action.payload.moneda;
      state["saldo_juego"] = action.payload["saldo_juego"];
      state["saldo_retiro"] = action.payload["saldo_retiro"];
      state["saldo_bonos"] = action.payload["saldo_bonos"];
      state.token = action.payload.token;
      state.tipo = action.payload.tipo;
      state.logged = true;
    },
    setUserData: (state, action) => {
      if (action.payload.apellido)
        state.nombre_completo =
          action.payload.nombre + " " + action.payload.apellido;
      else state.nombre_completo = action.payload.nombre;
      state.email = action.payload.email;
      state.telefono = action.payload.telefono;
      state.cedula = action.payload.cedula;
    },
    setEmailOrPhone: (state, action) => {
      state.email = action.payload.email;
      state.telefono = action.payload.telefono;
    },
    setNewToken: (state, action) => {
      state.token = action.payload;
    },
    setFactorUser: (state, action) => {
      state.factor1 = action.payload.factor_1;
      state.factor25 = action.payload.factor_25;
      state.factor05 = action.payload.factor_05;
    },
    updateBalance: (state, action) => {
      state["saldo_juego"] = action.payload.saldo_juego;
      state["saldo_retiro"] = action.payload.saldo_retiro;
      state["saldo_bonos"] = action.payload.saldo_bonos;
      state.documento_valido = action.payload.validacion_documento;
      state.personal_document = action.payload.personalDocument;
      state.verified = action.payload.verified;
    },
    setVerificaciones: (state, action) => {
      state.documento_valido = action.payload.validacion_documento;
      state.verified = action.payload.verified;
    },
    setUserBets: (state, action) => {
      state.estado_user = action.payload.estado;
      state.saldo_bonos = action.payload.bonos;
      state.saldo_retiro = action.payload.retiro;
      state.saldo_juego = action.payload.credito;
      state.bexacta = action.payload.bexacta;
      state.bpick2 = action.payload.bpick2;
      state.bpick3 = action.payload.bpick3;
      state.bpick4 = action.payload.bpick4;
      state.bpick5 = action.payload.bpick5;
      state.bpick6 = action.payload.bpick6;
      state.bplace = action.payload.bplace;
      state.bshow = action.payload.bshow;
      state.bsuperfecta = action.payload.bsuperfecta;
      state.btrifecta = action.payload.btrifecta;
      state.bwin = action.payload.bwin;
      state.factor1 = action.payload.factor_1;
      state.factor05 = action.payload.factor_05;
      state.factor25 = action.payload.factor_25;
      state.factor_exo = action.payload.factor_exo;
      state.limite_cantidad = action.payload.limite_cantidad;
      state.documento_valido = action.payload.validacion_documento;
      state.verified = action.payload.verified;
      state.personal_document = action.payload.personalDocument;
      state.imgPerfil = action.payload.img_perfil;
      state.casino_evo = action.payload.casino_evo;
      state.casino_ezug = action.payload.casino_ezug;
      state.casino_prag = action.payload.casino_prag;
      state.casino_tvbet = action.payload.casino_tvbet;
      state.slot_pragmatic = action.payload.slot_pragmatic;
      state.slot_spinmatic = action.payload.slot_spinmatic;
    },
    setCambioMoneda: (state, action) => {
      state.id = action.payload.id_uo;
      state.moneda = action.payload.moneda;
    },
    logout: (state) => {
      state.logged = false;
      state.id = "";
      state.nombre_completo = "";
      state.email = "";
      state.user = "";
      state.moneda = "";
      state.saldo_juego = "";
      state.saldo_retiro = "";
      state.saldo_bonos = "";
      state.foto = "";
      state.telefono = "";
      state.cedula = "";
      state.tipo = "";
      state.factor1 = "";
      state.factor25 = "";
      state.factor05 = "";
      state.bpick2 = "";
      state.bpick3 = "";
      state.bpick4 = "";
      state.bpick5 = "";
      state.bpick6 = "";
      state.bwin = "";
      state.bplace = "";
      state.bshow = "";
      state.bexacta = "";
      state.btrifecta = "";
      state.bsuperfecta = "";
      state.factor_exo = "";
      state.limite_cantidad = "";
      state.documento_valido = "";
      state.estado_user = "";
      state.token = "";
      state.typeSell = "";
      state.validacion_video = false;
      state.validacion_video_hipo = "";
      state.validacion_video_url = "";
      state.showVideo = "";
      state.personal_document = "";
      state.verified = "";
      state.activePage = "/";
      state.totalPago = false;
      state.id_totalPago = "";
      state.bonoCompleted = false;
      state.casino_evo = "";
      state.casino_ezug = "";
      state.casino_prag = "";
      state.casino_tvbet = "";
      state.slot_pragmatic = "";
      state.slot_spinmatic = "";
      state.blockNotVerifiedPeru = false;
    },
    setActivePage: (state, action) => {
      state.activePage = action.payload;
    },
    setBlockNotVerifiedPeru: (state, action) => {
      state.blockNotVerifiedPeru = action.payload;
    },
    setTypeSell: (state, action) => {
      state.typeSell = action.payload;
    },
    setValidacionVideo: (state, action) => {
      state.validacion_video = action.payload.active;
      state.validacion_video_hipo = action.payload.nombre;
      state.validacion_video_url = action.payload.url;
    },
    setShowVideo: (state, action) => {
      state.showVideo = action.payload;
    },
    setTotalPago: (state, action) => {
      state.totalPago = action.payload;
    },
    setIdTotalPago: (state, action) => {
      state.id_totalPago = action.payload;
    },
    setDetectedCountry: (state, action) => {
      state.detectedCountry = action.payload;
    },
    setCompletedBono: (state, action) => {
      state.bonoCompleted = action.payload;
    },
    setImgPerfil: (state, action) => {
      state.imgPerfil = action.payload;
    },
    setBlockDeposit: (state, action) => {
      state.blockDeposit = action.blockDeposit;
    },
    setBlockRetiro: (state, action) => {
      state.blockRetiro = action.payload;
    }
  },
});

export const {
  setUserLoginDetails,
  setShowVideo,
  logout,
  setActivePage,
  setUserData,
  setNewToken,
  setFactorUser,
  updateBalance,
  setUserBets,
  setCambioMoneda,
  setTypeSell,
  setValidacionVideo,
  setTotalPago,
  setIdTotalPago,
  setDetectedCountry,
  setCompletedBono,
  setImgPerfil,
  setVerificaciones,
  setBlockNotVerifiedPeru,
  setEmailOrPhone,
  setBlockDeposit,
  setBlockRetiro
} = userSlice.actions;

//para mostrar cada una si no vamos a hacer ningun cambio
export const selectLogged = (state) => state.user.logged;
export const selectUser = (state) => state.user.user;
export const selectCurrency = (state) => state.user.moneda;
export const selectGameBalance = (state) => state.user["saldo_juego"];
export const selectWithdrawBalance = (state) => state.user["saldo_retiro"];
export const selectSaldoBonos = (state) => state.user["saldo_bonos"];
export const selectToken = (state) => state.user.token;
export const selectId = (state) => state.user.id;
export const selectPhoneNumber = (state) => state.user.telefono;
export const selectFullname = (state) => state.user.nombre_completo;
export const selectDocumentId = (state) => state.user.cedula;
export const selectActivePage = (state) => state.user.activePage;
export const selectEmail = (state) => state.user.email;
export const selectFactor1 = (state) => state.user.factor1;
export const selectFactor25 = (state) => state.user.factor25;
export const selectFactor05 = (state) => state.user.factor05;

export const selectValidacionVideo = (state) => state.user.validacion_video;
export const selectValidacionVideoNombre = (state) =>
  state.user.validacion_video_hipo;
export const selectValidacionVideoUrl = (state) =>
  state.user.validacion_video_url;
export const selectShowVideo = (state) => state.user.showVideo;
export const selectTotalPago = (state) => state.user.totalPago;
export const selectIdTotalPago = (state) => state.user.id_totalPago;
export const selectCompletedBono = (state) => state.user.bonoCompleted;

/* USER BETS */

export const selectEstadoUser = (state) => state.user.estado_user;
export const selectBpick2 = (state) => state.user.bpick2;
export const selectBpick3 = (state) => state.user.bpick3;
export const selectBpick4 = (state) => state.user.bpick4;
export const selectBpick5 = (state) => state.user.bpick5;
export const selectBpick6 = (state) => state.user.bpick6;
export const selectBwin = (state) => state.user.bwin;
export const selectBPlace = (state) => state.user.bplace;
export const selectBshow = (state) => state.user.bshow;
export const selectBExacta = (state) => state.user.bexacta;
export const selectBtrifecta = (state) => state.user.btrifecta;
export const selectBsuperfecta = (state) => state.user.bsuperfecta;
export const selectFactorExotica = (state) => state.user.factor_exo;
export const selectLimiteCantidad = (state) => state.user.limite_cantidad;
export const selectDocumentoValidado = (state) => state.user.documento_valido;
export const selectIsVerified = (state) => state.user.verified;
export const selectPersonalDocument = (state) => state.user.personal_document;
export const selectFoto = (state) => state.user.imgPerfil;
export const selectTypeSell = (state) => state.user.typeSell;
export const selectTipo = (state) => state.user.tipo;
export const selectSlotprag = (state) => state.user.slot_pragmatic;
export const selectSlotspin = (state) => state.user.slot_spinmatic;
export const selectCasEvo = (state) => state.user.casino_evo;
export const selectCasEzu = (state) => state.user.casino_ezug;
export const selectCasPrag = (state) => state.user.casino_prag;
export const selectCasTvbet = (state) => state.user.casino_tvbet;
      

export const selectDetectedCountry = (state) => state.user.detectedCountry;
export const selectNotVerifiedPeru = (state) => state.user.blockNotVerifiedPeru;
export const selectBlockDeposit = (state) => state.user.blockDeposit;
export const selectBlockRetiro = (state) => state.user.blockRetiro;

export default userSlice.reducer;
